<template>
  <div>
    <q-dialog v-model="show" :maximized="maximized" @input="(val) => $emit('input', val)">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ invoiceSettlementDetailTitleLable }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container style="max-height: 85vh" class="scroll tw-p-6">
          <q-card-section v-if="data" class="tw-flex tw-flex-row tw-gap-4 tw-flex-between tw-w-full tw-h-full">
            <div class="card tw-w-1/2 mb-4">
              <div class="card-container tw-h-full">
                <div class="card-title">{{ $gettext('PERIOD') }}</div>
                <div class="card-body">
                  <div class="mb-4">
                    <div class="label">{{ $gettext('RATE_PERIOD')  }}:</div>
                    <div v-if="invoiceSettlementTypeNumber === invoiceSettlementType.EXEMPTION.key" class="value">{{ period }}</div>
                    <div v-if="invoiceSettlementTypeNumber !== invoiceSettlementType.EXEMPTION.key" class="value">{{ startDate }}</div>
                  </div>

                  <div  v-for="(property, index) in getInvoiceSettlementProperty()" :key="index"  >
                    <div class="label">{{property.label}}:</div>
                    <div class="value">
                      {{ buildLabelProperty(property)}}
                    </div>
                  </div>

                  <div>
                    <div class="label">{{$gettext('REASON')}}:</div>
                    <div class="value">
                      {{ periodObservation || $gettext('NO_OBSERVATION') }}
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="card tw-w-1/2 ">
                <div class="card-container tw-h-full">
                  <div class="card-title">{{ $gettext('INFORMATIONS_ATTACHMENTS')}}</div>
                  <div class="card-body">
                    <div class="mb-4">
                      <div class="label">{{$gettext('ARCHIVES')}}:</div>
                      <div class="flex items-center space-x-2" v-for="(file, index) in files" :key="index">
                        <button class="icon-button" @click="visualizeFile(file.file)">
                          <q-icon :name="getIconComponent(getFileType(file.file)).icon" size="45px" />
                        </button>
                        <div>
                          <div class="value">
                            {{ file.observation || $gettext('NO_OBSERVATION') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </q-card-section>
          <q-card-section v-if="finalStatus != null && finalStatus.status"
           class="tw-flex tw-flex-row tw-gap-4 tw-flex-between tw-w-full tw-h-full">
            <div class="tw-grid-rows tw-mt-8  tw-w-full tw-h-full">
              <info-box-panel class="tw-mt-4" :title="$gettext('APPROVAL_INFORMATIONS')">
                <template #body>
                  <div class="tw-flex tw-flex-row tw-gap-4 tw-flex-between tw-w-full tw-h-full">
                    <div class="tw-w-1/2 mb-4">
                      <info-box-panel-field :field="$gettext('ATTENDANT')" :value="attendant" />
                      <info-box-panel-field :field="$gettext('APPROVER')" :value="approverInfo.nome" />
                    </div>
                    <div class="tw-w-1/2 mb-4">
                      <info-box-panel-field :field="$gettext('DATE_HOUR')" :value="attendionDateTime" />
                      <info-box-panel-field :field="$gettext('DATE_HOUR')" :value="approverInfo.data" />
                    </div>
                    <div class="tw-w-1/2 mb-4">
                      <info-box-panel-field :field="$gettext('STATUS')" :value="getSettlementTypeByCode(finalStatus.status).text" />
                      <info-box-panel-field :field="$gettext('OBSERVATION')" :value="approverInfo.observatioon" />
                    </div>
                  </div>
                </template>
              </info-box-panel>
            </div>
          </q-card-section>
          <q-card-section>
            <info-box-panel class="tw-mt-3" :title="$gettext('INVOICES_SUMMARY_STEP') ">
              <template #body>
                <service-request-invoice-settlement-datable class="tw-mt-8" v-if="columnsList" :fields="fields" :invoices="invoices"
                                                            noneselect rowKey="boundResidue" :columnEdit="paintCell" />
              </template>
            </info-box-panel>
          </q-card-section>
        </q-page-container>
      </q-layout>
    </q-dialog>
    <file-viewer-modal
      v-if="showDoc"
      ref="docsModal"
      :buttonName="buttonName"
      :params="docParams"
      :nmIdentificacaoParserFile="nmIdentificacaoParserFile"
      @close-modal="closeDoc"
    />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
import ServiceRequestInvoiceSettlementDatable from './ServiceRequestInvoiceSettlementDatatable.vue'
import moment from 'moment'
import InfoBoxPanel from '../component/InfoBoxPanel.vue'
import InfoBoxPanelField from '../component/InfoBoxPanelField.vue'
import { settlementTypeMap } from '../component/settlementTypeMap.js'
import { invoiceSettlementStatus } from 'src/shared/inf-tabela-descricao/InvoiceSettlementStatus.enum.js'
import { invoiceSettlementType } from 'src/shared/inf-tabela-descricao/InvoiceSettlementType.enum.js'
import FileViewerModal from 'src/components/file-viewer-modal/FileViewerModal.vue'

@Component({
  name: 'ServiceRequestInvoiceSettlementDetail',
  components: {
    InfoBoxPanelField,
    InfoBoxPanel,
    JtDataTable,
    ServiceRequestInvoiceSettlementDatable,
    FileViewerModal
  },
  props: {
    id: Number,
    show: {
      type: Boolean,
      default: false
    },
    maximized: {
      type: Boolean,
      default: false
    }
  }
})

class ServiceRequestInvoiceSettlementDetail extends Vue {
  period = '';
  periodObservation = '';
  filesObservation = '';
  nmIdentificacaoParserFile = 'INVOICE_SETTLEMENT';
  files = [];
  showDoc = false;
  docParams = {};
  buttonName= 'icDetalharArquivo';
  data = null
  datatableModel = null
  datatable = null
  columnsList = null
  moment = moment;

  historic = []
  async mounted () {
    this.data = await this.load(this.id)
    this.columnsList = this.data[0].inputs.find(input => input.name === 'invoiceSettlement.detalharInvoiceSettlementById.invoiceSettlementInvoices').columns
    this.period = this.data[0].relacionamentos.invoiceSettlementInvoices[0].period
    this.periodObservation = this.data[0].relacionamentos.invoiceSettlementHistorys[0].observation

    this.historic = this.data[0].relacionamentos.invoiceSettlementHistorys
    this.files = this.data[0].relacionamentos.invoiceSettlementFiles
    this.invoices = this.data[0].relacionamentos.invoiceSettlementInvoices
    this.filesObservation = this.data[0].relacionamentos.invoiceSettlementFiles?.[0]?.observation
  }

  async load (id) {
    return await repository.resolve('invoiceSettlement.detalharInvoiceSettlementById', { id: id })
  }

  closeDoc () {
    this.showDoc = false
  }

  getHistory (codStatus) {
    return this.historic.find(history => history.codStatus === codStatus)
  }

  get invoiceSettlementStatus () {
    return invoiceSettlementStatus()
  }

  get invoiceSettlementDetailTitleLable () {
    return this.dadosForm?.invoiceSettlementType === 50380006 ? this.$gettext('SETTLEMENT_ADJUSTMENT_DETAIL_TITLE') + ' ' + this.id
      : this.$gettext('SETTLEMENT_EXEMPTION_DETAIL_TITLE') + ' ' + this.id
  }

  get dadosForm () {
    return this.data?.[0]?.dadosForm
  }

  get observation () {
    return this.data?.[0]?.dadosForm.observation
  }

  get attendant () {
    return this.attendantRow?.attendant
  }

  get invoiceSettlementType () {
    return invoiceSettlementType()
  }

  get attendantRow () {
    return this.getHistory(this.invoiceSettlementStatus.PENDING.key) || this.getHistory(this.invoiceSettlementStatus.UPDATE.key)
  }

  get finalStatus () {
    return this.getHistory(this.invoiceSettlementStatus.APPROVED.key) || this.getHistory(this.invoiceSettlementStatus.UPDATE.key) || this.getHistory(this.invoiceSettlementStatus.DENIED.key)
  }

  get attendionDateTime () {
    return this.attendantRow ? moment(this.attendantRow.date, 'YYYY-MM-DD HH:mm:ss.SSS').format('DD/MM/YYYY HH:mm:ss') : null
  }

  get startDate () {
    const startDateInicial = this.getInvoiceSettlementPropertyName('startDateInicial') || {}
    const startDateFinal = this.getInvoiceSettlementPropertyName('startDateFinal') || {}
    return startDateInicial.label + ': ' + startDateInicial.newValue + ' / ' + startDateFinal.label + ': ' + startDateFinal.newValue
  }

  closeModal = function () {
    this.$emit('update:renderDetailModal', false)
    this.$emit('update:editMode', false)
    this.$emit('update:detailMode', false)
    this.$emit('update:searchMode', false)
  }

  getFileType (file) {
    const extension = file.split('.').pop().toLowerCase()

    if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'].includes(extension)) {
      return 'documento'
    } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
      return 'imagem'
    } else if (['mp4', 'avi', 'mov', 'wmv', 'mkv'].includes(extension)) {
      return 'video'
    } else {
      return 'mdi-paperclip'
    }
  }

  get settlementType () {
    return settlementTypeMap()
  }

  get invoiceSettlementTypeNumber () {
    return this.data?.[0]?.dadosForm?.invoiceSettlementType
  }

  get invoiceSettlementProperty () {
    return this.data?.[0]?.relacionamentos?.invoiceSettlementProperty || []
  }

  getInvoiceSettlementPropertyName (name) {
    return this.invoiceSettlementProperty.find(property => property.name === name)
  }

  getInvoiceSettlementProperty () {
    return this.invoiceSettlementProperty.filter(property => !(property.name === 'startDateInicial' || property.name === 'startDateFinal'))
  }

  getSettlementTypeByCode (code) {
    if (code) {
      for (const settlement in this.settlementType) {
        if (
          Object.prototype.hasOwnProperty.call(this.settlementType, settlement)
        ) {
          const settlementKeys = this.settlementType[settlement].keys || []
          if (settlementKeys.includes(code)) {
            return this.settlementType[settlement]
          }
        }
      }
    }
    return { text: code, color: '#fff' }
  }

  get approverInfo () {
    const history = this.historic
    let aprovadorReprovador = null
    let dataAprovacaoReprovacao = null
    let observationAprovador = null

    for (const item of history) {
      if (item.invoiceSettlementStatus !== this.invoiceSettlementStatus.PENDING.key) {
        aprovadorReprovador = item.attendant
        observationAprovador = item.observation
        dataAprovacaoReprovacao = moment(item.date, 'YYYY-MM-DD HH:mm:ss.SSS').format('DD/MM/YYYY HH:mm:ss')
      }
    }

    return {
      nome: aprovadorReprovador,
      data: dataAprovacaoReprovacao,
      observatioon: observationAprovador
    }
  }

  getIconComponent (tipo) {
    switch (tipo) {
      case 'documento':
        return { icon: 'mdi-paperclip' }
      case 'imagem':
        return { icon: 'mdi-image-multiple' }
      case 'video':
        return { icon: 'mdi-video' }
      default:
        return { icon: 'mdi-file-outline' }
    }
  }

  async visualizeFile (filePath) {
    this.docParams = {
      name: filePath
    }
    this.showDoc = true
  }

  buildLabelProperty (property) {
    return this.$gettext('FROM_PROPERTY') + ': ' + property.oldValue + ' ' + this.$gettext('TO_PROPERTY') + ': ' + property.newValue
  }

  get fields () {
    const columns = []
    if (this.columnsList?.length > 0) {
      Object.keys(this.columnsList).map((key) => {
        const label = this.columnsList[key].label
        if (label) {
          columns.push({
            name: this.columnsList[key].name,
            label: this.columnsList[key].label,
            type: this.columnsList[key].dataType,
            model: this.columnsList[key].name,
            dataType: this.columnsList[key].dataType,
            edit: false,
            render: this.columnsList[key].render,
            field: this.columnsList[key].name,
            visibility: 'show',
            sortable: true,
            align: this.columnsList[key].align
          })
        }
      })
    }
    return columns
  }
}
export default ServiceRequestInvoiceSettlementDetail
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";

.q-icon {
  color: #3B4259;
}

.q-page-container {
  padding-top: 60px !important;
}

.visualization-container {
  font-family: Arial, sans-serif;
}

.header {
  color: white;
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.close-btn {
  background-color: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
}

.content-container {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.card {
  background-color: white;
}

.card-container {
  position: relative;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
  margin-top: 1rem;
  padding: 1rem;
}

.card-title {
  position: absolute;
  top: -0.75rem;
  left: 1rem;
  background-color: white;
  padding: 0 0.5rem;
  color: #3B4259;
  font-weight: bold;
}

.card-body {
  padding: 0.75rem 0;
}

.label {
  color: #3B4259;
  font-weight: bold;
  margin-bottom: 0.25rem;
}

.value {
  margin-bottom: 0.75rem;
  color: #6b7280;
  padding: 0.5rem;
  background-color: #f5f5f5;
}

.icon-button {
  background: none;
  border: none;
  cursor: pointer;
}

.mb-4 {
  margin-bottom: 1rem;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.space-x-2>*+* {
  margin-left: 0.5rem;
}

@media (max-width: 768px) {
  .content-container {
    flex-direction: column;
  }

}
</style>
